const labels = {
  All: { 'See the offering': 'Se erbjudande' },
  FacilityDetails: { 'Ref: Page title': 'Site information', 'Ref: Review': 'Feedback' },
  FacilitiesList: { 'Ref: Page title': 'Anläggningar', 'Ref: See details': 'Se detaljer' },
};
export default labels;
